import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../components/UI/Spinner";
import ErrorModal from "../components/UI/Error";
import { pricingService } from "../services";


export default function SubscriptionPage() {
  const navigate = useNavigate();
const [loading, setLoading] = useState(true);
const [error, setError] = useState(false);
const [errorMessage, setErrorMessage]=useState("")
const [plans, setPlans]= useState([]);
useEffect(()=>{
  const fetchPlans = async () => {
    try {
      setError(false);
      const plans = await pricingService.allPricingPlans();
      setPlans(plans)
    } catch (error) {
      setError(true)
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
    }
  };
  fetchPlans();
},[])
if(loading) return <div className="grid place-content-center h-[60vh]"><Spinner/></div>;
if(error) return <ErrorModal isOpen={error} onClose={()=>setError(false)} title={"Error Getting Plans"} message={`${errorMessage || "There is error while trying to fetch the subscription plans. Please check your internet contivities and refresh this page to try again"}`} />;

  return (
    <div className="min-h-screen bg-gray-200 text-black py-8 px-4">
      <h1 className="text-2xl text-gray-800 font-bold text-center mb-5">Choose a Plan</h1>
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="bg-gray-900 rounded-2xl p-6 shadow-md hover:shadow-xl transition duration-300 relative"
          >
            <h2 className="text-2xl font-semibold mb-2 text-white">{plan.name}</h2>
            <p className="text-3xl font-bold mb-4 text-yellow-600"> ₦ {plan.price}</p>
            <p className="text-sm text-zinc-400 mb-4">{plan.uploads} uploads included</p>
            <ul className="mb-8 space-y-2">
              {plan.info.map((feature, idx) => (
                <li key={idx} className="flex items-center gap-2 border-separate text-white">
                  <span className="text-green-400">✓</span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            <button
              onClick={() => navigate("/checkout", { state: { plan } })}
              className="formSubmitBtn bg-yellow-800 hover:bg-yellow-700 transition absolute bottom-1 w-[90%] m-auto"
            >
              Subscribe
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}